import {CommonModule} from "@angular/common";
import {HTTP_INTERCEPTORS} from "@angular/common/http";
import {NgModule} from "@angular/core";
import {DefaultHttpInterceptor} from "../shared/interceptors/default-http-interceptors";
import {SharedModule} from "../shared/shared-module";
import {UserFormComponent} from "./user/user-form/user-form.component";
import {UsersComponent} from "./user/users/users.component";
import {AdministrationComponent} from "./administration/administration.component";
import {ApplicationListComponent} from "./application-project/application-list/application-list.component";
import {ApplicationComponent} from "./application-project/application/application.component";
import {ProjectListComponent} from "./application-project/project-list/project-list.component";
import {ProjectComponent} from "./application-project/project/project.component";
import {CollectedDataComponent} from "./collected-data/collected-data.component";
import {CoreRoutingModule} from "./core-routing.module";
import {CoreComponent} from "./core.component";
import {DefaultComponent} from "./default/default.component";
import {ImportDataComponent} from "./import-data/import-data.component";
import {JiraErrorListComponent} from "./import-data/jira-import/jira-error-list/jira-error-list.component";
import {JiraErrorComponent} from "./import-data/jira-import/jira-error/jira-error.component";
import {JiraImportComponent} from "./import-data/jira-import/jira-import.component";
import {PackExportComponent} from "./import-data/pack-export/pack-export.component";
import {PackImportComponent} from "./import-data/pack-import/pack-import.component";
import {NotFoundComponent} from "./not-found/not-found.component";
import {OrderFormListComponent} from "./orders-forms/order-form-list/order-form-list.component";
import {OrderFormComponent} from "./orders-forms/order-form/order-form.component";
import {CalculateEcheancesComponent} from "./pack-generation/calculate-echeances/calculate-echeances.component";
import {CommentPromptComponent} from "./pack-generation/calculate-echeances/dialog-box/comment-prompt.component";
import {CommentBoxComponent} from "./pack-generation/calculate-echeances/dialog-box/comment-box.component";
import {
  EcheanceDetailsComponent
} from "./pack-generation/calculate-echeances/echeance-details/echeance-details.component";
import {EcheancesListComponent} from "./pack-generation/calculate-echeances/echeances-list/echeances-list.component";
import {PackGenerationComponent} from "./pack-generation/pack-generation/pack-generation.component";
import {ApplicationDomainComponent} from "./service-manager/application-domain/application-domain.component";
import {ApplicationSettingsComponent} from './application-settings/application-settings.component';
import {DomainesComponent} from './domaines/domaines.component';
import {DomainesListComponent} from './domaines-list/domaines-list.component';
import {CalendrierFormComponent} from './calendrier-pack/calendrier-form/calendrier-form.component';
import {CalendrierFormListComponent} from './calendrier-pack/calendrier-form-list/calendrier-form-list.component';
import {MatDatepickerModule} from "@angular/material/datepicker";
import {MatNativeDateModule} from "@angular/material/core";
import {MatFormFieldModule} from "@angular/material/form-field";
import {MatInputModule} from "@angular/material/input";
import {NettingFormComponent} from './netting-account/netting-form/netting-form.component';
import {NettingFormListComponent} from './netting-account/netting-form-list/netting-form-list.component';
import {NettingSchemaFormComponent} from './netting-schema/netting-schema-form/netting-schema-form.component';
import {
  NettingSchemaFormListComponent
} from './netting-schema/netting-schema-form-list/netting-schema-form-list.component';
import {ExcludedDemandFormComponent} from './excluded-demand/excluded-demand-form/excluded-demand-form.component';
import {ExcludedDemandListComponent} from './excluded-demand/excluded-demand-list/excluded-demand-list.component';
import {DashboardComponent} from "./dashboard/dashboard.component";
import {DashboardMenuComponent} from "./dashboard/dashboard-menu/dashboard-menu.component";
import {DashboardAlertComponent} from "./dashboard/dashboard-alert/dashboard-alert.component";
import {DashboardOrderComponent} from "./dashboard/dashboard-order/dashboard-order.component";
import {DashboardAppsComponent} from "./dashboard/dashboard-apps/dashboard-apps.component";
import {RepositoryManagerComponent} from "./application-settings/repository-manager/repository-manager.component";
import {FileManagerComponent} from "./application-settings/file-manager/file-manager.component";
import {MatRadioModule} from '@angular/material/radio';
import {MatListModule} from '@angular/material/list';
import {FacturationComponent} from "./facturations/facturation/facturation.component";
import {FacturationListComponent} from "./facturations/facturation-list/facturation-list.component";
import {FacturationImportComponent} from "./facturations/facturation-import/facturation-import.component";
import {
  FacturationNettingRegularisationComponentForm
} from "./facturations/facturation-netting_regularisation/facturation-netting_regularisation-form/facturation-netting_regularisation.component";
import {
  FacturationNettingListComponent
} from "./facturations/facturation-netting_regularisation/facturation-netting-list/facturation-netting-list.component";
import {FacturationVueNettingComponent} from "./facturations/facturation-vue_netting/facturation-vue_netting.component";
import {MatGridListModule} from "@angular/material/grid-list";
import {
  PurgeModalConfirmationComponent
} from './application-settings/purge-modal-confirmation/purge-modal-confirmation.component';
import {
  CalenderModalConfirmationComponent
} from './calendrier-pack/calender-modal-confirmation/calender-modal-confirmation.component';
import { ClosingPackModalComponent } from './application-settings/closing-pack-modal/closing-pack-modal.component';
import { FusionPackModalComponent } from './application-settings/fusion-pack-modal/fusion-pack-modal.component';
import { FebActiviteUoNomenclatureManagementComponent } from "./feb-activite-uo-nomenclature-management/feb-activite-uo-nomenclature-management.component";
import { FebActiviteUoNomenclatureDialogComponent } from "./feb-activite-uo-nomenclature-management/feb-activite-uo-nomenclature-dialog/feb-activite-uo-nomenclature-dialog.component";
import { FebLocationsManagementComponent } from "./feb-locations-management/feb-locations-management.component";
import { FebLocationFormComponent } from "./feb-locations-management/feb-location-form/feb-location-form.component";
import { FicheExpressionBesoinComponent } from "./fiche-expression-besoin/fiche-expression-besoin.component";
import { FicheExpressionBesoinDialogComponent } from "./fiche-expression-besoin/fiche-expression-besoin-dialog/fiche-expression-besoin-dialog.component";
import { DevisManagementComponent } from './devis/devis-management.component';
import { DevisDialogComponent } from './devis/devis-dialog/devis-dialog.component';
import { DevisCreateDialogComponent } from './devis/devis-create-dialog/devis-create-dialog.component';
import { DevisValidationComponent } from './devis/devis-validation/devis-validation.component';
import { DevisValidateDialogComponent } from './devis/devis-validation/devis-validate-dialog/devis-validate-dialog.component';
import { DevisRefuseDialogComponent } from './devis/devis-validation/devis-refuse-dialog/devis-refuse-dialog.component';
import { DevisRetourDialogComponent } from './devis/devis-retour-dialog/devis-retour-dialog.component';
import { DevisViewDialogComponent } from './devis/devis-view-dialog/devis-view-dialog.component';
import { AuditManagementComponent } from "./audit-management/audit-management.component";
import { NettingPrelevementFormListComponent } from "./netting-prelevement/netting-prelevement-form-list/netting-prelevement-form-list.component";
import { NettingPrelevementFormComponent } from './netting-prelevement/netting-prelevement-form/netting-prelevement-form.component';
import { DemandHistoryComponent } from "./pack-generation/calculate-echeances/echeance-details/demand-history/demand-history.component";
import { AuditDetailDialogComponent } from "./audit-management/audit-detail-dialog/audit-detail-dialog.component";
import { DevisHistoryComponent } from "./devis/devis-view-dialog/devis-history/devis-history.component";
import { FebHistoryComponent } from "./fiche-expression-besoin/feb-viewer/feb-history/feb-history.component";
import { FebViewerComponent } from "./fiche-expression-besoin/feb-viewer/feb-viewer.component";
import { UoListComponent } from "./uo-evaluation/uo-evaluation.component";
import { UoDialogComponent } from "./uo-evaluation/uo-dialog/uo-dialog.component";
import { CategorieListComponent } from "./categorie-list/categorie-list.component";
import { CompetenceListComponent } from "./competence-list/competence-list.component";
import { CompetenceDialogComponent } from "./competence-list/competence-dialog/competence-dialog.component";
import { EvaluationFormComponent } from "./evaluation-list/evaluation-form/evaluation-form.component";
import { EvaluationListComponent } from "./evaluation-list/evaluation-list.component";
import { EvaluationTableComponent } from "./evaluation-list/evaluation-table/evaluation-table.component";
import { NoteCellComponent } from "./evaluation-list/evaluation-table/evaluation-cell/note-cell.component";
import { ConfirmDialogComponent } from "./evaluation-list/evaluation-table/confirm-dialog/confirm-dialog.component";
import { AddLignesDialogComponent } from "./evaluation-list/add-ligne-dialog/add-lignes-dialog.component";
import { CentreCompetenceMenuComponent } from './centre-competence-menu/centre-competence-menu.component';
import { LoginInfoDialogComponent } from "../shared/dialogs/login-info-dialog/login-info-dialog.component";
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { PostesListComponent } from './postes-list/postes-list.component';
import { PosteDialogComponent } from './postes-list/poste-dialog/poste-dialog.component';
import { CollaborateursListComponent } from './collaborateurs-list/collaborateurs-list.component';
import { CollaborateurDialogComponent } from './collaborateurs-list/collaborateur-dialog/collaborateur-dialog.component';
import { CvViewerDialogComponent } from './collaborateurs-list/cv-viewer-dialog/cv-viewer-dialog.component';
import { DevisCollaborateursComponent } from './devis/devis-collaborateurs/devis-collaborateurs.component';
import { DuplicateFebDialogComponent } from "../shared/dialogs/duplicate-feb-dialog/duplicate-feb-dialog.component";


@NgModule({
  imports: [
    SharedModule,
    CoreRoutingModule,
    CommonModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatFormFieldModule,
    MatInputModule,
    MatRadioModule,
    MatListModule,
    MatGridListModule,
    MatButtonToggleModule
  ],
  exports: [],
  declarations: [
    CoreComponent,
    OrderFormComponent,
    OrderFormListComponent,
    AdministrationComponent,
    ProjectComponent,
    ApplicationComponent,
    ApplicationListComponent,
    ProjectListComponent,
    UsersComponent,
    UserFormComponent,
    JiraImportComponent,
    JiraErrorListComponent,
    JiraErrorComponent,
    PackGenerationComponent,
    PackImportComponent,
    CalculateEcheancesComponent,
    CollectedDataComponent,
    EcheancesListComponent,
    ImportDataComponent,
    PackExportComponent,
    EcheanceDetailsComponent,
    NotFoundComponent,
    DefaultComponent,
    CommentBoxComponent,
    CommentPromptComponent,
    ApplicationDomainComponent,
    ApplicationSettingsComponent,
    DomainesComponent,
    DomainesListComponent,
    CalendrierFormComponent,
    CalendrierFormListComponent,
    NettingFormComponent,
    NettingFormListComponent,
    NettingSchemaFormComponent,
    NettingSchemaFormListComponent,
    NettingPrelevementFormComponent,
    NettingPrelevementFormListComponent,
    ExcludedDemandFormComponent,
    ExcludedDemandListComponent,
    DashboardComponent,
    DashboardMenuComponent,
    DashboardAlertComponent,
    DashboardOrderComponent,
    DashboardAppsComponent,
    RepositoryManagerComponent,
    FileManagerComponent,
    FacturationComponent,
    FacturationListComponent,
    FacturationImportComponent,
    FacturationNettingRegularisationComponentForm,
    FacturationNettingListComponent,
    FacturationVueNettingComponent,
    PurgeModalConfirmationComponent,
    CalenderModalConfirmationComponent,
    ClosingPackModalComponent,
    FusionPackModalComponent,
    FebActiviteUoNomenclatureManagementComponent,
    FebActiviteUoNomenclatureDialogComponent,
    FebLocationsManagementComponent,
    FebLocationFormComponent,
    FicheExpressionBesoinComponent,
    FicheExpressionBesoinDialogComponent,
    DevisManagementComponent,
    DevisDialogComponent,
    DevisCreateDialogComponent,
    DevisValidationComponent,
    DevisValidateDialogComponent,
    DevisRefuseDialogComponent,
    DevisRetourDialogComponent,
    DevisViewDialogComponent,
    AuditManagementComponent,
    DemandHistoryComponent,
    AuditDetailDialogComponent,
    DevisHistoryComponent,
    FebHistoryComponent,
    FebViewerComponent,
    UoListComponent,
    UoDialogComponent,
    CategorieListComponent,
    CompetenceListComponent,
    CompetenceDialogComponent,
    EvaluationFormComponent,
    EvaluationListComponent,
    EvaluationTableComponent,
    NoteCellComponent,
    ConfirmDialogComponent,
    AddLignesDialogComponent,
    CentreCompetenceMenuComponent,
    LoginInfoDialogComponent,
    PostesListComponent,
    PosteDialogComponent,
    CollaborateursListComponent,
    CollaborateurDialogComponent,
    CvViewerDialogComponent,
    DevisCollaborateursComponent,
    DuplicateFebDialogComponent
  ],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: DefaultHttpInterceptor,
      multi: true
    },
    MatDatepickerModule,
  ],
  bootstrap: [CoreComponent],

})
export class CoreModule {
}
